import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@material-ui/styles';
import {
  Grid,
  FormControl,
  TextField,
  InputAdornment,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  MenuItem
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useDispatch, useSelector } from 'react-redux';
import CButton from '../../component/Button';
import { setAccount } from '../../actions/accountAction';
import { DefaultSelect } from '../../component/Select';

const theme = createTheme({
  overrides: {
    MuiDialog: {
      root: {
        '& .MuiDialog-paper': {
          borderRadius: '12px',
          height: '268px',
          padding: '24px',
          width: '560px'
        },
        '& .MuiDialogContent-root': {
          '& :nth-child(2)': {
            alignSelf: 'flex-start !important'
          },
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '56px',
          overflow: 'hidden',
          padding: '5px 0 !important',
          radius: '8px',
          width: '512px'
        },
        '& .MuiDialogTitle-root': {
          fontSize: '20px',
          padding: '0'
        },
        '& .MuiInputBase-root': {
          margin: '5px 0',
          padding: '0'
        },
        '& .ant-btn': {
          fontWeight: '600'
        },
        '& .dialogbutton-center': {
          color: '#5564F8'
        }
      }
    },
    MuiSelect: {
      nativeInput: {
        color: 'red'
      },
      root: {
        backgroundColor: '#EFF0F6 !important',
        border: '#FF0000',
        borderRadius: '8px',
        boxSizing: 'border-box',
        height: '56px',
        textAlign: 'left'
      }
    },
    MuiTextField: {
      root: {
        '& .MuiInputBase-root': {
          backgroundColor: '#EFF0F6',
          borderRadius: '8px',
          boxSizing: 'border-box',
          height: '56px'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            backgroundColor: 'white',
            borderColor: '#CAD8FF',
            zIndex: -1
          },
          borderRadius: '10px',
          fontFamily: 'Poppins',
          fontSize: '14px',
          height: '40px',
          zIndex: 1
        },
        '& .small-input': {
          display: 'inline-flex !important',
          width: '45% !important'
        }
      }
    }
  }
});

const buttonXStyle = {
  borderRadius: '10px',
  height: '40px',
  marginLeft: '0',
  width: '85px'
};

const formStyle = {
  marginBottom: '48px',
  marginTop: '48px',
  width: '384px'
};

const Information = ({ submit, error }) => {
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [mobileVerCode, setMobileVerCode] = useState('');
  const [emailVerCode, setEmailVerCode] = useState('');

  const countries = ['Georgia', 'USA', 'Ukraine', 'France'];

  const dispatch = useDispatch();

  const userDraft = useSelector(({ account }) => account.userDraft);

  const openMobileModal = () => {
    if (userDraft.phone.length >= 14) {
      setOpen(true);
    }
  };
  const openEmailModal = () => {
    if (userDraft.email.length) {
      setOpenEmail(true);
    }
  };

  const verifyMobile = () => {
    handleClose();
    setMobileVerified(mobileVerCode === '1111');
  };

  const verifyEmail = () => {
    handleCloseEmail();
    setEmailVerified(emailVerCode === '1111');
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseEmail = () => {
    setOpenEmail(false);
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      setAccount({
        ...userDraft,
        [name]: value
      })
    );
  };

  return (
    <FormControl>
      <form autoComplete="off" noValidate style={formStyle}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                className="small-input"
                error={!!(submit && userDraft.name?.length < 2)}
                id="outlined-error"
                name="name"
                onChange={onInputChange}
                placeholder="John*"
                required
                type="text"
                value={userDraft.name || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                className="small-input"
                error={!!(submit && userDraft.surname?.length < 2)}
                id="outlined-error"
                name="surname"
                onChange={onInputChange}
                placeholder="Doe*"
                required
                type="text"
                value={userDraft.surname || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={9}>
              <TextField
                error={!!(submit && !userDraft.email.length)}
                fullWidth
                id="outlined-error"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {emailVerified ? (
                        <CheckCircleIcon style={{ color: '#00BA88' }} />
                      ) : (
                        <>
                          <Dialog
                            aria-labelledby="form-dialog-title"
                            fullWidth
                            maxWidth="sm"
                            onClose={handleClose}
                            open={openEmail}
                          >
                            <DialogTitle id="form-dialog-title">Email verification</DialogTitle>
                            <DialogContent>
                              <TextField
                                fullWidth
                                id="name"
                                onChange={(e) => setEmailVerCode(e.target.value)}
                                placeholder="Enter verification code"
                                type="text"
                                variant="outlined"
                              />
                              <DialogContentText>
                                Email with verification code was sent to {userDraft.email}
                              </DialogContentText>
                              <CButton className="dialogbutton-center" type="secondary">
                                Resend
                              </CButton>
                            </DialogContent>
                            <DialogActions>
                              <CButton onClick={handleCloseEmail} type="secondary">
                                Cancel
                              </CButton>
                              <CButton onClick={(e) => verifyEmail(e)} type="primary">
                                Verify
                              </CButton>
                            </DialogActions>
                          </Dialog>
                        </>
                      )}
                    </InputAdornment>
                  )
                }}
                onChange={(e) => dispatch(setAccount({ ...userDraft, email: e.target.value }))}
                placeholder="randommail@example.com*"
                required
                type="email"
                value={userDraft.email || ''}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <CButton onClick={openEmailModal} size="medium" type="primary" xstyle={buttonXStyle}>
                Verify
              </CButton>
            </Grid>

            <Grid item xs={9}>
              <InputMask
                mask={`+\\ 999 999 999 999`}
                maskChar=""
                name="phone"
                onChange={(e) => dispatch(setAccount({ ...userDraft, phone: e.target.value }))}
                value={userDraft.phone || ''}
              >
                {() => (
                  <TextField
                    error={!!(submit && userDraft.phone?.length < 10)}
                    fullWidth
                    id="outlined-error"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {mobileVerified ? (
                            <CheckCircleIcon style={{ color: '#00BA88' }} />
                          ) : (
                            <>
                              <Dialog
                                aria-labelledby="form-dialog-title"
                                fullWidth
                                maxWidth="sm"
                                onClose={handleClose}
                                open={open}
                              >
                                <DialogTitle id="form-dialog-title">
                                  Mobile number verification
                                </DialogTitle>
                                <DialogContent>
                                  <TextField
                                    fullWidth
                                    id="name"
                                    onChange={(e) => setMobileVerCode(e.target.value)}
                                    placeholder="Enter verification code"
                                    type="text"
                                    variant="outlined"
                                  />
                                  <DialogContentText>
                                    SMS with verification code was sent to {userDraft.phone}
                                  </DialogContentText>
                                  <CButton className="dialogbutton-center" type="secondary">
                                    Resend
                                  </CButton>
                                </DialogContent>
                                <DialogActions>
                                  <CButton onClick={handleClose} type="secondary">
                                    Cancel
                                  </CButton>
                                  <CButton onClick={(e) => verifyMobile(e)} type="primary">
                                    Verify
                                  </CButton>
                                </DialogActions>
                              </Dialog>
                            </>
                          )}
                        </InputAdornment>
                      )
                    }}
                    placeholder="+995 593 123 456*"
                    required
                    type="text"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={3}>
              <CButton onClick={openMobileModal} size="medium" type="primary" xstyle={buttonXStyle}>
                Verify
              </CButton>
            </Grid>

            <Grid item xs={12}>
              <InputMask
                mask="99999999999"
                maskChar=""
                onChange={(e) => dispatch(setAccount({ ...userDraft, id: e.target.value }))}
                value={userDraft.id || ''}
              >
                {() => (
                  <TextField
                    error={!!(submit && userDraft.id?.length < 11)}
                    fullWidth
                    id="outlined-error"
                    placeholder="0123456789*"
                    required
                    type="text"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={!!(submit && userDraft.addressRequired?.length < 2)}
                fullWidth
                id="outlined-error"
                name="addressRequired"
                onChange={onInputChange}
                placeholder="E33, Chavchavadze Ave*"
                required
                type="text"
                value={userDraft.addressRequired || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                name="addressOptional"
                onChange={onInputChange}
                placeholder="Address line 2 (Optional)"
                type="text"
                value={userDraft.addressOptional || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                className="small-input"
                error={!!(submit && userDraft.city?.length < 2)}
                id="outlined-error"
                name="city"
                onChange={onInputChange}
                placeholder="Tbilisi*"
                required
                type="text"
                value={userDraft.city || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={6}>
              <InputMask
                mask="9999"
                maskChar=""
                onChange={(e) => dispatch(setAccount({ ...userDraft, postal: e.target.value }))}
                value={userDraft.postal || ''}
              >
                {() => (
                  <TextField
                    className="small-input"
                    error={!!(submit && userDraft.postal?.length < 4)}
                    id="outlined-error"
                    placeholder="0179*"
                    required
                    type="text"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>

            <Grid item xs={12}>
              <DefaultSelect
                onSelect={(value) => {
                  dispatch(setAccount({ ...userDraft, country: value }));
                }}
                value={userDraft.country || 'Georgia'}
              >
                {countries.map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </DefaultSelect>
            </Grid>
          </Grid>

          <div
            style={{
              color: 'red',
              display: error && submit ? 'block' : 'none'
            }}
          >
            Please fill in the required fields
          </div>
        </ThemeProvider>
      </form>
    </FormControl>
  );
};

export default Information;
